import * as React from "react"
import IEditedBy from "../../models/IEditedBy";
import {default as EditViewCard, EditViewDisplayMode} from "../../components/common/EditViewCard";
import IDifferentialDiagnosis from "../../models/IDifferentialDiagnosis";
import {LOADING_STATE} from "../../utils/AppUtils";
import ModelFactory from "../../models/ModelFactory";
import {isNull as _isNull} from "lodash";
import AppLoader from "../../components/utils/AppLoader";
import {PatientDiagnosisViewProps} from "../../components/patient/view/PatientDiagnosisView";
import {PatientDifferentialDiagnosisEditorProps} from "../../components/patient/edit/PatientDifferentialDiagnosisEditor";

export interface DifferentialDiagnosisEditViewContProps {
    editedBy?: IEditedBy,
    appointmentId?: number,
    differentialDiagnosisSaveState: LOADING_STATE,
    patientDifferentialDiagnosis: IDifferentialDiagnosis,
    fetchDifferentialDiagnosis?: (appointmentId: number) => any,
    saveDifferentialDiagnosis?: (patientDifferentialDiagnosis: IDifferentialDiagnosis) => any,
    showLoginPrompt?: () => void,
    displayMode?: EditViewDisplayMode,
    doctorType: string,
    curefitUserId: string
}

export interface DifferentialDiagnosisEditViewContState {
    updatedDifferentialDiagnosis: {item: IDifferentialDiagnosis},
    isDifferentialDiagnosisDataLoaded: LOADING_STATE
}

class DifferentialDiagnosisEditViewCont extends React.Component<DifferentialDiagnosisEditViewContProps, DifferentialDiagnosisEditViewContState> {
    constructor(props: DifferentialDiagnosisEditViewContProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    getStateFromProps = (props: DifferentialDiagnosisEditViewContProps) => {
        let currState: DifferentialDiagnosisEditViewContState = {
            updatedDifferentialDiagnosis: null,
            isDifferentialDiagnosisDataLoaded: LOADING_STATE.NOT_INITIALIZED
        }
        if ( _isNull(props.patientDifferentialDiagnosis) ) {
            props.fetchDifferentialDiagnosis(this.props.appointmentId);
            currState.isDifferentialDiagnosisDataLoaded = LOADING_STATE.LOADING;
        } else {
            currState.updatedDifferentialDiagnosis = {item: props.patientDifferentialDiagnosis};
            currState.isDifferentialDiagnosisDataLoaded = LOADING_STATE.LOADED;
        }
        return currState;
    }

    componentWillReceiveProps(props: DifferentialDiagnosisEditViewContProps) {
        this.setState(this.getStateFromProps(props));
    }

    getDiagnosisEditViewTemplateProps = () => {
        let differentialDiagnosisViewProps: PatientDiagnosisViewProps = {
            diagnosis: this.props.patientDifferentialDiagnosis
        }
        let differentialDiagnosisEditorProps: PatientDifferentialDiagnosisEditorProps = {
            updateDifferentialDiagnosis: this.updateDifferentialDiagnosis,
            updatedDifferentialDiagnosis: this.state.updatedDifferentialDiagnosis
        }
        return {"view": differentialDiagnosisViewProps, "edit": differentialDiagnosisEditorProps};
    }

    getUpdatedDiagnosisFromProps = (props: DifferentialDiagnosisEditViewContProps): { item: IDifferentialDiagnosis } => {
        let currUpdatedDifferentialDiagnosis: {item: IDifferentialDiagnosis} = {item: ModelFactory.createNewDifferentialDiagnosis()};
        currUpdatedDifferentialDiagnosis = {
            item: props.patientDifferentialDiagnosis
        };
        return currUpdatedDifferentialDiagnosis;
    }

    cancelActionHandler = () => {
        this.setState({updatedDifferentialDiagnosis: this.getUpdatedDiagnosisFromProps(this.props)});
    }

    updateDifferentialDiagnosis = (updatedDifferentialDiagnosis: {item: IDifferentialDiagnosis}) => {
        this.setState({updatedDifferentialDiagnosis: updatedDifferentialDiagnosis});
    }

    savePatientDifferentialDiagnosis = () => {
        let myInstance = this;
        let saveDiagnosis: IDifferentialDiagnosis = this.getSaveObject();

        if (ModelFactory.isValidDifferentialDiagnosis(saveDiagnosis)) {
            this.setState({isDifferentialDiagnosisDataLoaded: LOADING_STATE.NOT_INITIALIZED})
            this.props.saveDifferentialDiagnosis(saveDiagnosis).then(function(){
                myInstance.setState({isDifferentialDiagnosisDataLoaded: LOADING_STATE.LOADED})
            });
        }
    }

    saveDifferencialDiagnosis = () => {
        this.props.saveDifferentialDiagnosis(this.state.updatedDifferentialDiagnosis.item)
    }

    // navigateToDashboard = () => {
    //     this.props.showLoginPrompt()
    // }

    getSaveObject = (): IDifferentialDiagnosis => {
        let saveDifferentialDiagnosis: IDifferentialDiagnosis
        saveDifferentialDiagnosis = this.state.updatedDifferentialDiagnosis.item;
        return saveDifferentialDiagnosis;
    }

    render() {
        let isDiagnosisDataLoaded =  this.state.isDifferentialDiagnosisDataLoaded === LOADING_STATE.LOADED;
        let buttonText = this.props.differentialDiagnosisSaveState === LOADING_STATE.LOADING ? "Saving..." : "Submit";
        return (
            <div className="diagnosis-editview-cont">
                {
                    isDiagnosisDataLoaded &&
                    <EditViewCard 
                        cardTitleDisplay={"Private Notes"}
                        templateName={"differentialDiagnosis"}
                        templateProps={this.getDiagnosisEditViewTemplateProps()}
                        lastEditedEpoch={new Date().getTime()}
                        saveActionHandler={this.savePatientDifferentialDiagnosis}
                        cancelActionHandler={this.cancelActionHandler}
                        displayMode={this.props.displayMode}
                    />
                }
                {
                    isDiagnosisDataLoaded &&
                    <div className={"footer"}>
                        <div className="save-button collapsible-card button-container">
                            <input className="card-primary-action send-prescription" type="button" value={buttonText} disabled={this.props.differentialDiagnosisSaveState === LOADING_STATE.LOADING} onClick={this.saveDifferencialDiagnosis} />
                        </div>
                    </div>
                }
                {
                    !isDiagnosisDataLoaded &&
                    <AppLoader/>
                }
            </div>
        );
    }
}

export default DifferentialDiagnosisEditViewCont;